import { Checkbox } from "@/shared/components/ui/checkbox";
import { CheckedState } from "@radix-ui/react-checkbox";
import { useToast } from "@/shared/hooks/use-toast";
import { parseRTKQueryError } from "@/shared/components/errors/parse-r-t-k-query-error";
import {
  useHtzAhuComponentCatalogPutActiveCatalogMutation,
  useHtzAhuComponentCatalogShowActiveCatalogQuery,
} from "@/services/backend/htz/ahu/api/ahu-component-catalog-api";

export interface ActiveAhuComponentCatalogCheckboxProps {
  companyId: string;
  catalogId: string;
}

export function ActiveAhuComponentCatalogCheckbox({
  companyId,
  catalogId,
}: ActiveAhuComponentCatalogCheckboxProps) {
  const { data: activeCatalog } =
    useHtzAhuComponentCatalogShowActiveCatalogQuery({ companyId });

  const [put, { isLoading, error, reset }] =
    useHtzAhuComponentCatalogPutActiveCatalogMutation();

  const { toast } = useToast();

  if (error) {
    toast({
      ...parseRTKQueryError(error),
      variant: "destructive",
    });
    reset();
  }

  if (!activeCatalog) {
    return null;
  }

  const checked = activeCatalog.catalogId === catalogId;
  const onCheckedChange = (newState: CheckedState) => {
    if (isLoading) {
      return;
    }

    switch (newState) {
      case true:
        put({ companyId, catalogId });
        break;
      case false:
        put({ companyId, catalogId: null });
        break;
      case "indeterminate":
        break;
      default:
        break;
    }
  };

  return (
    <Checkbox
      checked={checked}
      onCheckedChange={onCheckedChange}
      className={isLoading ? "animate-pulse" : ""}
      disabled={isLoading}
    />
  );
}
